import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'sample-result',
  templateUrl: './sample-result.component.html',
  styleUrls: ['./sample-result.component.scss']
})
export class SampleResultComponent {

  @Input() sections: any[] = [];
  @Input() currentSectionIndex = 0;
  @Input() currentQuestionIndex = 0;
  @Input() questionStates: { [key: string]: any } = {};
  @Input() questionScores = new Map<any, boolean>();
  @Input() getQuestionContent: (questionId: any) => any;
  @Input() sectionTitleSlug = 'title_section';
  @Input() hideUnscoredSections = false;
  @Input() showLeaveButton = true;

  @Output() sectionQuestionSelected = new EventEmitter<{ sectionIndex: number, questionIndex: number }>();
  @Output() leave = new EventEmitter<void>();

  @ViewChild('questionReviewRunner', { static: false }) questionReviewRunner: ElementRef<HTMLDivElement>;

  getActiveQuestionId() {
    const questions = this.getSectionQuestions(this.currentSectionIndex);
    return questions[this.currentQuestionIndex];
  }

  getActiveQuestionContent() {
    const questionId = this.getActiveQuestionId();
    if (!questionId || !this.getQuestionContent) {
      return null;
    }
    return this.getQuestionContent(questionId);
  }

  getActiveQuestionState() {
    const questionId = this.getActiveQuestionId();
    if (!questionId) {
      return {};
    }
    let qState = this.questionStates[questionId];
    if (!qState) {
      qState = this.questionStates[questionId] = {};
    }
    return qState;
  }

  getQuestionScore(id: any) {
    return this.questionScores.get(id);
  }

  selectSectionAndQuestion(sectionIndex: number, questionIndex: number) {
    this.sectionQuestionSelected.emit({ sectionIndex, questionIndex });
    this.scrollQuestionIntoView();
  }

  private getSectionQuestions(sectionIndex: number) {
    return this.sections[sectionIndex]?.questions || [];
  }

  private scrollQuestionIntoView() {
    if (this.questionReviewRunner?.nativeElement) {
      this.questionReviewRunner.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}
